import React, { Fragment } from 'react';

// const renderPostalAddress = (postalAddress) => postalAddress.join(' - ');
const renderPostalAddress = (postalAddress) => postalAddress;

const renderSchedules = (schedules) => (
  <>
    {schedules.map((cur, idx) => {
      const br = idx > 0 ? <br /> : null;
      return (
        <Fragment key={idx}>
          {br}
          <span>{cur}</span>
        </Fragment>
      );
    })}
  </>
);

// TODO: Reformat for label. May use REGEX
const renderPhoneNumber = (phoneNumber) => ({ label: phoneNumber, value: phoneNumber });

export { renderPostalAddress, renderSchedules, renderPhoneNumber };
